@if (!form().valid) {
  <aw-button
    [id]="'show-errors'"
    [style]="'primary'"
    (click)="revealFormErrors()"
    [type]="'submit'"
    [text]="'Zeige Fehler'"></aw-button>
}
